// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__5nMDt","navigation":"style_navigation__1im2u","icon":"style_icon__1obd6","tabIcon":"style_tabIcon__1MfOn","centeredCard":"style_centeredCard__3IdH_"};